<template>
  <div>
    <!-- 视频预览的弹窗 -->
    <el-dialog :visible.sync="videoDialogVisible" :modal-append-to-body="false" append-to-body
      :before-close="handleClose">
      <div class="video-dialog">
        <video ref="video" :src="videoUrl" controls="controls" autoplay="autoplay" width="100%"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'WebSassVideo',
  props: {
    /** 视频的url */
    videoUrl: {
      type: String,
      default: ''
    },
    /** 视频预览的弹窗的显隐 */
    videoDialogVisible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {

    };
  },

  mounted() {

  },
  /** 监听对话框 关闭的时候 要停止播放 */
  watch: {
    videoDialogVisible(newValue) {
      if (!newValue) {
        // 获取视频元素并停止播放
        const videoElement = this.$refs.video;
        if (videoElement) {
          videoElement.pause();
        }
      }
    }
  },
  methods: {
    /** 关闭视频预览的弹窗 */
    handleClose() {
      this.$emit('update:videoDialogVisible', false)
    }

  },
};
</script>

<style lang="scss" scoped></style>